export default {
  getToken(state) {
    return state.user.access_token;
  },
};
